import { render, staticRenderFns } from "./changes.vue?vue&type=template&id=18ee3e9c&scoped=true"
import script from "./changes.vue?vue&type=script&lang=js"
export * from "./changes.vue?vue&type=script&lang=js"
import style0 from "./changes.vue?vue&type=style&index=0&id=18ee3e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ee3e9c",
  null
  
)

export default component.exports